import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    redirectAlert: translate({ id: 'territoryCalendar.warning.trackingRedirect' }),
  }))

  return api
}
